// extracted by mini-css-extract-plugin
export var autoExpand = "_10-8";
export var container = "_10-7";
export var containerWidth = "_10-5";
export var disabled = "_10-2";
export var error = "_10-3";
export var fullWidth = "_10-6";
export var inputWrapper = "_10-0";
export var small = "_10-1";
export var textarea = "_10-4";